import { LocalizationService } from '@abp/ng.core';
import { Component, Input, OnInit } from '@angular/core';
import { EmailDirection } from 'src/core/models/generic-lookup-type/email/email-direction.glt';

@Component({
    selector: 'ca-email-direction-icon',
    templateUrl: './email-direction-icon.component.html',
    styleUrls: ['./email-direction-icon.component.scss', '../conversation-icons.scss'],
    standalone: false
})
export class EmailDirectionIconComponent implements OnInit {
  @Input()
  directionId: number | null;

  get iconCls(): string {
    let result = '';

    switch (this.directionId) {
      case EmailDirection.sent:
        result = 'fas fa-sign-in-alt fa-flip-horizontal';
        break;
      case EmailDirection.received:
        result = 'fas fa-sign-in-alt';
        break;
      default:
        result = 'fas fa-question';
    }

    return result;
  }

  get tooltip(): string {
    switch (this.directionId) {
      case EmailDirection.sent:
        return this.localizationService.instant('Conversation::EmailDirectionSent');
      case EmailDirection.received:
        return this.localizationService.instant('Conversation::EmailDirectionReceived');
      default:
        return this.localizationService.instant('Query::Unknown');
    }
  }

  constructor(private localizationService: LocalizationService) {}

  ngOnInit(): void {}
}
